module.exports = __webpack_public_path__ + "static/media/prionto.21f17516.png";